// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","hero__title":"Hero_hero__title__tqFlB","select":"Hero_select__rLrFh","clock__wrapper":"Hero_clock__wrapper__XCmgw","div":"Hero_div__6DFU5"};